import { useEffect, useRef, useState } from 'react';
import { Input } from 'barte-design-system';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';

import { INPUT_SEARCH_DEFAULT_DEBOUNCE_MS } from './input-search.constants';

import styles from './input-search.module.css';

import type { InputSearchProps } from './input-search.type';

export const InputSearch = ({
    placeholder,
    initialValue = '',
    debounceMs = INPUT_SEARCH_DEFAULT_DEBOUNCE_MS,
    onDebouncedChange,
    className,
}: InputSearchProps) => {
    const [value, setValue] = useState(initialValue);
    const lastEmitted = useRef<string>(initialValue.trim());
    const onDebouncedChangeRef = useRef(onDebouncedChange);

    useEffect(() => {
        onDebouncedChangeRef.current = onDebouncedChange;
    }, [onDebouncedChange]);

    useEffect(() => {
        const handler = setTimeout(() => {
            const trimmed = value.trim();
            if (trimmed === lastEmitted.current) {
                return;
            }
            lastEmitted.current = trimmed;
            onDebouncedChangeRef.current(trimmed);
        }, debounceMs);

        return () => clearTimeout(handler);
    }, [value, debounceMs]);

    return (
        <div className={`${styles.wrapper} ${className ?? ''}`.trim()}>
            <Input
                icon={MagnifyingGlassIcon}
                placeholder={placeholder}
                value={value}
                onChange={(event) => setValue(event.target.value)}
            />
        </div>
    );
};
